import * as R from "ramda";

import formatDateFn from "date-fns/fp/format";
import parseDateFn from "date-fns/fp/parse";
import isValidDate from "date-fns/fp/isValid";

export const URL_DATE_FORMAT = "yyyy-MM-dd";

export const formatDateForUrl = formatDateFn(URL_DATE_FORMAT);

export const formatDateForFrontend = formatDateFn("M/dd/yyyy");

// parse the date and default to today
export const parseUrlDate = R.compose(
  R.unless(isValidDate, () => new Date()),
  parseDateFn(new Date(), URL_DATE_FORMAT),
);
